import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { PutEcshopAccountsService } from "@/features/accounts/ecshop/services/put-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { MoneyLinkError, MoneyLinkException, ErrorLevel } from "@/shared/utils/custom-exception";


export const usePutEcshopAccounts = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const putEcshopAccountsService = new PutEcshopAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // 金融機関更新
  const updateEcshopAccounts = async (
    accountGroupId: string,
    ecshopAccountId: string,
    ecshopId: string,
    selectedStatus?: number,
    inputShopTitle?: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await putEcshopAccountsService.putEcshopAccounts({
        account_group_id: accountGroupId,
        ecshop_account_id: ecshopAccountId,
        ecshop_id: ecshopId,
        ...(selectedStatus !== undefined && { selected_status: selectedStatus }),
        ...(inputShopTitle !== undefined && { input_shop_title: inputShopTitle }),
      });
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("updateEcshopAccounts:", error);
      if (
        error instanceof MoneyLinkException &&
        error.error.props.reason === "webmoneylink_parameter_error"
      ) {
        throw new MoneyLinkException({
          error: new MoneyLinkError({
            level: ErrorLevel.Warn,
            code: error.error.props.code,
            reason: error.error.props.reason,
            messageTitle: undefined,
            messageBody:
              "Web明細帳名に使用できない文字が含まれているか、文字数が上限を超えています。\n入力内容をご確認ください。",
          }),
        });
      }
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    updateEcshopAccounts: errorHandledAsync(updateEcshopAccounts, setError),
  };
};
